<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import printInvoice from '@/components/print-invoice'

export default {
  page: {
    title: "Invoice  Confirmation",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader },
  setup (props) {
    const inv_id = props.inv_id
    const createInvoice = () => {
      printInvoice(inv_id)
    }
    return {
      createInvoice
    }
  },
  props: {
    inv_id : Number
  },
  data() {
    return {
      
    };
  },
  computed: {
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
              <b-alert show variant="success">
                Your Invoice has been created successfully.<br/>
              </b-alert>
              <br/>
              <b-button id="invprint" variant="success" @click="createInvoice">
                <i class="mdi mdi-file-download-outline align-middle"></i>
                Download Invoice
              </b-button>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>